export default __webpack_public_path__ + "static/media/batch.753c7fd1.svg";